import { render, staticRenderFns } from "./questionDetails.vue?vue&type=template&id=3adb787a"
import script from "./questionDetails.vue?vue&type=script&lang=js"
export * from "./questionDetails.vue?vue&type=script&lang=js"
import style0 from "./questionDetails.vue?vue&type=style&index=0&id=3adb787a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports